module.exports = "<div class=\"modal fade\" id=\"banner-modal-{{trailId}}\" data-backdrop=\"false\">\r\n    <div class=\"modal-dialog\">\r\n        <app-banner [item]=\"banner.data[0]\"></app-banner>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/listagem-cursos/banner/banner.component.html
// module id = ./src/app/shared/listagem-cursos/banner/banner.component.html
// module chunks = main